import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import { BrandingProvider } from '@/context/BrandingContext';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Leads from '@/pages/Leads';
import LeadForm from '@/pages/LeadForm';
import LeadDetail from '@/pages/LeadDetail';
import LeadEdit from '@/pages/LeadEdit';
import Users from '@/pages/Users';
import Lenders from '@/pages/Lenders';
import Branches from '@/pages/Branches';
import FollowUps from '@/pages/FollowUps';
import Activities from '@/pages/Activities';
import Settings from '@/pages/Settings';
import Customers from '@/pages/Customers';
import Loans from '@/pages/Loans';
import Documents from '@/pages/Documents';
import Reports from '@/pages/Reports';
import Roles from '@/pages/Roles';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }
  return !isAuthenticated ? children : <Navigate to="/dashboard" />;
};

function AppContent() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/leads" element={<PrivateRoute><Leads /></PrivateRoute>} />
      <Route path="/leads/new" element={<PrivateRoute><LeadForm /></PrivateRoute>} />
      <Route path="/leads/:leadId" element={<PrivateRoute><LeadDetail /></PrivateRoute>} />
      <Route path="/leads/:leadId/edit" element={<PrivateRoute><LeadEdit /></PrivateRoute>} />
      <Route path="/users" element={<PrivateRoute><Users /></PrivateRoute>} />
      <Route path="/lenders" element={<PrivateRoute><Lenders /></PrivateRoute>} />
      <Route path="/branches" element={<PrivateRoute><Branches /></PrivateRoute>} />
      <Route path="/followups" element={<PrivateRoute><FollowUps /></PrivateRoute>} />
      <Route path="/activities" element={<PrivateRoute><Activities /></PrivateRoute>} />
      <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
      <Route path="/customers" element={<PrivateRoute><Customers /></PrivateRoute>} />
      <Route path="/loans" element={<PrivateRoute><Loans /></PrivateRoute>} />
      <Route path="/documents" element={<PrivateRoute><Documents /></PrivateRoute>} />
      <Route path="/reports" element={<PrivateRoute><Reports /></PrivateRoute>} />
      <Route path="/roles" element={<PrivateRoute><Roles /></PrivateRoute>} />
      <Route path="/" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

function App() {
  return (
    <BrandingProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppContent />
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </BrandingProvider>
  );
}

export default App;
